$ = require 'jquery'
Action = require 'app/scripts/models/action'
ActivityMemberMenuView = require 'app/scripts/views/member-menu-profile/activity-member-menu-view'
{ attachmentsDomain, siteDomain } = require '@trello/config'
AttachmentHelpers = require 'app/scripts/views/attachment/helpers'
AttachmentViewer = require 'app/scripts/views/internal/attachment-viewer'
Auth = require 'app/scripts/db/auth'
Board = require 'app/scripts/models/board'
BoardDisplayHelpers = require 'app/scripts/views/internal/board-display-helpers'
Browser = require '@trello/browser'
Card = require 'app/scripts/models/card'
Controller = require 'app/scripts/controller'
Dates = require 'app/scripts/lib/dates'
EntityDisplay = require 'app/scripts/lib/entity-display'
hasSelection = require 'app/scripts/lib/util/selection/has-selection'
KnownServices = require 'app/scripts/db/known-services'
ModelCache = require 'app/scripts/db/model-cache'
PopOver = require 'app/scripts/views/lib/pop-over'
React = require 'react'
ReactDOM = require '@trello/react-dom-wrapper'
ReactionPiles = require 'app/scripts/views/reactions/reaction-piles'
TFM = require 'app/scripts/lib/markdown/tfm'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
friendlyLinks = require 'app/scripts/views/internal/friendly-links'
log = require 'app/scripts/debug/log'
moment = require 'moment'
templates = require 'app/scripts/views/internal/templates'
{ track, trackUe } = require '@trello/analytics'
l = require 'app/scripts/lib/localize'
actionTemplate = require 'app/scripts/views/templates/action'

module.exports = class ActionView extends View
  className: 'phenom'

  initialize: ({ @context, @highlighted }) ->
    @listenTo @model, 'takingTooLong change', @render
    data = @model.get('data')
    if(data.card?.id? && data.board)
      @listenTo @modelCache, "remove:Action:#{ @model.get('id') }", =>
        @remove()

      if (card = @model.getCard())? && card.id != @context.id
        @listenTo card, 'change:name', @render

    if (checklist = @model.getChecklist())?
      @listenTo checklist, 'change:name', @render

    @listenTo @model.reactionList, 'add remove reset', @renderReactions

    # TODO: bind to the memberCreator properly
    # TODO: bind to labelNames properly

  events:
    'click .js-show-mem-menu': 'viewMemberActionMenu'
    'click .js-open-attachment-viewer': 'openAttachmentViewer'
    'click .js-open-card': 'openCard'
    'click .js-reply-to-action': 'reply'
    'click .js-reply-to-all-action': 'replyAll'
    'click .js-expand-comment': 'expandComment'
    'click a': 'checkAttachment'

  getData: ->
    entities = new EntityDisplay('action')
      .getEntities(@model.getDisplay(), @context.id)

    saved: @model.id?
    entities: _.map(entities, @_withEntityInfo.bind(@))
    date: @model.get('date')
    dateLastEdited: @model.get('data').dateLastEdited
    textData: @model.get('data').textData
    url: if @model.getCard()? then Controller.getActionUrl(@model) else null

  getTrackingContext: ->
    { card, list, board } = @model.get('data')

    category =
      if @context.typeName == 'Card'
        'card detail'
      else
        'board sidebar'

    _.extend {},
      actionId: @model.id
      cardId: card?.id
      listId: list?.id
      boardId: board?.id
    , { category }

  trackWithData: (verb, dirObj, prepObj, indObj, method) ->
    { category } = @getTrackingContext()
    actionData = JSON.stringify _.omit(@getTrackingContext(), 'category')

    trackUe(category, verb, dirObj, prepObj, indObj, method, actionData)

  getContext: ->
    context = {}
    me = Auth.me()

    board = @modelCache.get('Board', @model.get('data')?.board?.id)
    if @options.showBoard
      if board?
        context.board = board.toJSON(prefs: true, url: true)
        context.boardPLevelIconClass = BoardDisplayHelpers.getPermLevelIconClassForBoard(board)
        context.boardPLevelAltText = BoardDisplayHelpers.getPermLevelAltTextForBoard(board)

    if @options.showOrganization
      organization = @modelCache.get('Organization', @model.get('data')?.organization?.id)
      if organization?
        context.organization = organization.toJSON(prefs: true, url: true)
        context.orgPLevelIconClass = organization.getPermLevel()
        context.orgPLevelAltText = l(['org perms', organization.getPermLevel(), 'text'])

    memberCreator = @modelCache.get('Member', @model.get('idMemberCreator'))

    context.canReply =
      board?.canComment(me) &&
      (
        @model.isAddAttachment() ||
        (@model.isCommentLike() && memberCreator? && !Auth.isMe(memberCreator))
      )
    context.canReplyAll = context.canReply &&
      new RegExp(/@([a-z0-9_]+)/).test(@model.get('data').text)
    context.canDelete = @model.deletable()
    context.canEdit = @model.editable()
    context.member = memberCreator?.toJSON()
    context.member?.url = Controller.getMemberProfileUrl(context.member.id)
    context.showReactions =
      @context.typeName == 'Card' && @model.get('type') == 'commentCard'
    context.canReact = @model.canReact()
    context.showInlineReactionButton = context.showReactions && !@model.reactionList.length

    return context

  getOptions: ->
    showCompactAttachmentPreview: @options.compact
    truncateComment: @options.truncateComments?(@model) ? false
    showOptions:
      !@model.isPlaceholder() && !@options.compact && !@options.readOnly
    useEmbedly: !@options.compact && @model.isCommentLike()
    usePreviews: !@options.compact && @model.isAddAttachment()
    extremeTruncation: @options.extremeTruncation

  render: ->
    data = @getData()
    options = @getOptions()
    context = @getContext()

    log('actions', data)

    @$el.addClass if @model.isCommentLike()
      'mod-comment-type'
    else
      'mod-attachment-type'

    @$el.html actionTemplate(data, context, options)

    # Some actions wouldn't have a board associated with them
    if (board = @model.getBoard())?
      @$('.js-friendly-links').each -> friendlyLinks @, board

    if options.useEmbedly
      $embedly = @$('.js-embedly')
      # Let's see if there's any embedly stuff to throw on here
      for entity in data.entities when entity.type == 'comment' && entity.embedly?
        try
          for url, urlData of JSON.parse(entity.embedly)
            # Wistia includes have a security vulnerability, don't use them
            if /wistia/i.test(url)
              continue
            urlData["type_#{ urlData.type }"] = true
            urlData.requireHttps = true
            $embedly.show().append(templates.fill('embedly', urlData))

    if options.usePreviews
      attachments = _.filter data.entities, (entity) ->
        entity.type == 'attachment'

      if !_.isEmpty(attachments)
        $previews = @$('.js-previews')
        KnownServices.previewHtml attachments[0].url, (err, preview) ->
          $previews.empty()
          if err?
            if err.login?
              $('<div>')
                .addClass('attachment-extra-info-login')
                .html(err.login)
                .appendTo($previews)

              $previews.removeClass('hide')

          else if preview?
            $('<div>')
              .addClass('attachment-extra-info')
              .html(preview)
              .appendTo($previews)

            $previews.removeClass('hide')

    Dates.update(@el)

    @$el.toggleClass('unsent', !!@model.isTakingTooLong)
    @renderHighlighted()
    @renderReactions()

    @

  renderHighlighted: ->
    @$el.toggleClass('mod-highlighted', !!@highlighted)
    @

  renderReactions: ->
    context = @getContext()

    if @reactRoot = @$('.js-reaction-piles')[0]
      ReactDOM.render(React.createElement(ReactionPiles, {
        actionId: @model.id,
        reactionList: @model.reactionList,
        canReact: context.canReact,
        trackingContext: @getTrackingContext()
      }), @reactRoot)

  remove: ->
    if @reactRoot
      ReactDOM.unmountComponentAtNode(@reactRoot)
    super

  # TrelloFlavoredMarkdown opts for this action entity
  _tfmFormatOpts: ->
    card: @model.get('data').card
    board: @model.get('data').board
    siteDomain
    textData: @model.get('data').textData

  # Add additional info to an entity for rendering
  _withEntityInfo: (entityIn) ->
    entity = _.clone(entityIn)

    if entity.type == 'attachment'
      entity.url = @model.get('data').attachment.url

      # Handle friendly deleted link
      if !entity.url && entity.isFriendly
        entity.url = entity.text

    if entity.type == 'attachmentPreview'
      # Set preview URL to use for the browser's DPI
      # The entity has preview URLs already, but those don't always do the right thing with EXIF rotation
      entity.previewUrlForRes =
        if (card = ModelCache.get('Card', @model.get('data').card?.id))? && (attachment = card.attachmentList.get(@model.get('data').attachment?.id))
          if Browser.isHighDPI()
            (attachment.smallestPreviewBiggerThan(1000) ? attachment.biggestPreview())?.url
          else
            (attachment.smallestPreviewBiggerThan(500) ? attachment.biggestPreview())?.url

      entity.previewUrlForRes ?=
        if Browser.isHighDPI() && entity.previewUrl2x?
          entity.previewUrl2x
        else
          entity.previewUrl

    if entity.type == 'comment'
      entity.textHtml = TFM.comments.format(entity.text, @_tfmFormatOpts())
        .output

    if entity.type == 'checkItem'
      entity.nameHtml = TFM.checkItems.format(entity.text, @_tfmFormatOpts())
        .output

    if entity.type == 'date'
      entity.text = moment(entity.date).calendar()

    # Use the most recent name for the card, if available
    if entity.type == 'card' && (card = ModelCache.get('Card', entity.id))?
      entity.text = card.get('name')

    if entity.type == 'checklist' && (checklist = ModelCache.get('Checklist', entity.id))?
      entity.text = checklist.get('name')

    entity

  viewMemberActionMenu: (e) ->
    Util.stop(e)

    member = @modelCache.get('Member', $(e.target).closest('[idmember]').attr("idmember") ? @model.get('idMemberCreator'))

    PopOver.toggle
      elem: @$(e.target).closest('.js-show-mem-menu')
      view: ActivityMemberMenuView
      options:
        model: member
        modelCache: @modelCache

    return

  expandComment: (e) ->
    Util.stop(e)
    @$('.js-comment').removeClass 'is-truncated'

  openCard: (e) ->
    if @context.typeName == 'Card' || $(e.target).is('a,textarea')
      # Let the browser do the normal thing, e.g. open the link or edit
      return

    # If they've just selected some text, they aren't trying to open the card
    if hasSelection()
      return

    Util.stop(e)
    # Navigate to the action URL
    if (url = Controller.getActionUrl(@model))?
      Controller.navigate(url, { trigger: true })
    return

  openAttachmentViewer: (e) ->
    if e.metaKey || e.ctrlKey
      return

    $target = $(e.target)
    if $target.closest('.window-main-col').length > 0
      Util.stop(e)
      if !AttachmentViewer.isActive()
        idAttachment = $target.closest('.js-open-attachment-viewer').attr('data-idattachment')
        AttachmentViewer.show
          model: @model.getCard()
          idAttachment: idAttachment
    return

  reply: (e) ->
    Util.stop(e)
    @$el.trigger('replyToAction', @model)
    track("Card", "Reply to Comment")

  replyAll: (e) ->
    Util.stop(e)
    @$el.trigger('replyToAllAction', @model)
    track("Card", "Reply to all Comment")

  setHighlighted: (highlighted) ->
    if highlighted != @highlighted
      @highlighted = highlighted
      @renderHighlighted()
    return

  checkAttachment: (e) ->
    if e.metaKey || e.ctrlKey
      return

    card = @model.getCard()
    href = e.currentTarget.href
    if card? && href.indexOf(attachmentsDomain) == 0 && href.indexOf(card.id) != -1
      attachment = card.attachmentList.find (attachment) ->
        attachment.get('url') == href

      if attachment? && AttachmentHelpers.isViewerable(Util.fileExt(attachment.get('url')))
        e.preventDefault()
        AttachmentViewer.show
          model: card
          idAttachment: attachment.id
